<template>
	<div
		class="embedded-genogram-legend-row"
		:class="rowClassComputed"
		@mouseenter="onMouseEnter"
		@mouseleave="onMouseLeave"
		@click="onClick"
	>
		<GenogramLegendSymbolIcon
			v-if="rowType === 'symbol'"
			:src="src"
			:alt="text"
			:type="symbolType"
			:size="18"
			:is-primary-person="isPrimaryPerson"
			:is-passed-away="isPassedAway"
			:sexual-communication="sexualCommunication"
		/>
		<img
			v-else-if="rowType === 'line'"
			:src="src"
			:alt="text"
			:class="lineClassComputed"
		>
		<span
			v-else-if="rowType === 'dot'"
			class="embedded-genogram-legend-row__dot"
			:style="{backgroundColor: color}"
		></span>
		<span class="embedded-genogram-legend-row__text">{{ text }}</span>
	</div>
</template>

<script>
import GenogramLegendSymbolIcon from "./GenogramLegendSymbolIcon.vue";

export default {
	name: "EmbeddedGenogramLegendRow",
	components: {GenogramLegendSymbolIcon},

	props: {
		rowType: {type: String, required: true},
		text: {type: String, required: true},
		src: {type: String, default: ""},
		symbolType: {type: String, default: ""},
		sexualCommunication: {type: String, default: ""},
		color: {type: String, default: ""},
		isFamilyLine: Boolean,
		isPrimaryPerson: Boolean,
		isPassedAway: Boolean,
		hoverItem: {type: Object, default: null},
		isHoverable: Boolean,
		isLocked: Boolean,
		isHovered: Boolean,
	},

	computed: {
		rowClassComputed() {
			return {
				"embedded-genogram-legend-row--hoverable": this.isHoverable,
				"embedded-genogram-legend-row--locked": this.isLocked,
				"embedded-genogram-legend-row--hovered": this.isHovered && !this.isLocked,
			}
		},
		lineClassComputed() {
			return {
				"embedded-genogram-legend-row__line": true,
				"embedded-genogram-legend-row__line--family": this.isFamilyLine,
			}
		},
	},

	methods: {
		onMouseEnter() {
			if(!this.isHoverable || !this.hoverItem){
				return
			}

			this.$emit("hover-start", this.hoverItem)
		},
		onMouseLeave() {
			if(!this.isHoverable){
				return
			}

			this.$emit("hover-end")
		},
		onClick() {
			if(!this.isHoverable || !this.hoverItem){
				return
			}

			this.$emit("toggle-lock", this.hoverItem)
		},
	},
}
</script>

<style lang="scss">
.embedded-genogram-legend-row{
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 0;
	padding: 4px 6px;
	border: 1px solid transparent;
	border-radius: 8px;
	transition: background-color 0.15s ease, border-color 0.15s ease;
}

.embedded-genogram-legend-row--hoverable{
	cursor: pointer;
}

.embedded-genogram-legend-row--hovered{
	background: rgba(1, 105, 217, 0.08);
}

.embedded-genogram-legend-row--locked{
	background: rgba(1, 105, 217, 0.14);
	border-color: rgba(1, 105, 217, 0.34);
}

.embedded-genogram-legend-row__line{
	flex: 0 0 auto;
	width: 46px;
	height: 10px;
	object-fit: contain;
}

.embedded-genogram-legend-row__line--family{
	height: 14px;
}

.embedded-genogram-legend-row__dot{
	flex: 0 0 auto;
	width: 10px;
	height: 10px;
	border-radius: 50%;
}

.embedded-genogram-legend-row__text{
	flex: 1 1 auto;
	min-width: 0;
	font-size: 12px;
	line-height: 1.3;
	color: #243b53;
	white-space: normal;
	overflow-wrap: break-word;
}
</style>
